import Api from '@/services/api';
import type {
	FindAllKeyResultRequestDTO,
	FindAllKeyResultResponseDTO,
	BulkCreateKeyResultRequestDTO,
	BulkCreateKeyResultResponseDTO,
	BulkDeleteKeyResultRequestDTO,
	BulkDeleteKeyResultResponseDTO
} from '@/core/dto/ergonomic-work-analisys';
import { GetSelectedStepKeyResultsMapper } from '@/core/mapper/get-selected-step-key-results';
import type { EwaSelectedStepKeyResult } from '@/types/ErgonomicWorkAnalysis';

export class ErgonomicWorkAnalysisKeyResultService {
	private static instance: ErgonomicWorkAnalysisKeyResultService;

	private constructor(public readonly basePath: string = '/ergonomic-work-analysis-key-result') {}

	public static getInstance(): ErgonomicWorkAnalysisKeyResultService {
		if (!ErgonomicWorkAnalysisKeyResultService.instance) {
			ErgonomicWorkAnalysisKeyResultService.instance = new ErgonomicWorkAnalysisKeyResultService();
		}
		return ErgonomicWorkAnalysisKeyResultService.instance;
	}

	public async findAll(params: FindAllKeyResultRequestDTO): Promise<FindAllKeyResultResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await Api.get<EwaSelectedStepKeyResult[]>(url, { params });
		return new GetSelectedStepKeyResultsMapper(data).toDomain();
	}

	public async bulkCreate(params: BulkCreateKeyResultRequestDTO): Promise<BulkCreateKeyResultResponseDTO> {
		const url = this.basePath + `/bulk/by-custom-report-result-ids`;
		const { data } = await Api.post<BulkCreateKeyResultResponseDTO>(url, params);
		return data;
	}

	public async bulkDelete(params: BulkDeleteKeyResultRequestDTO): Promise<BulkDeleteKeyResultResponseDTO> {
		const url = this.basePath + `/bulk/by-step-key`;
		const { data } = await Api.delete<BulkDeleteKeyResultResponseDTO>(url, { params });
		return data;
	}
}
